export default __webpack_public_path__ + "static/media/404.2751ed71.svg";